@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: gridContainer from "../../styles/composable/layout.module.css";
}

.recipeHeader {
    grid-column: var(--grid-column);
    columns: 2 auto;
    margin-bottom: var(--spacer-24);

    @media ($below-mobile) {
        columns: 1;
    }
}

.note {
    margin-bottom: 1em;
}
